export const STEP_REQUEST_SUBMITTED = 'requestSubmitted';
export const STEP_IN_PROGRESS = 'inProgress';
export const STEP_COMPLETE = 'complete';
